<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="logQuery">
                        <InputField style="margin: 0.1rem 0.1rem 0.1rem 0;width:20%" labelWidth="0" type="text" id="code" v-model="form.code" placeholder="资产编码"/>
                        <InputField style="margin: 0.1rem 0.1rem 0.1rem 0;width:20%" labelWidth="0" type="text" id="name" v-model="form.name" placeholder="资产名称"/>
                        <SelectField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0;padding:0 0.2rem;width:20%;" :options="statusList" v-model="form.status" id="status" placeholder="资产状态"/>
                        <a-space style="margin: 0 0 0 0.5rem;width:25%">
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                        </a-space>
                    </div>
                </div>
            </form>
        </div>
        <Tablelist style="margin-top: 1rem"
                   :showCheckbox="false"
                   :list="list"
                   :columns="tableColumns"
                   :totalSize="totalSize"
                   :totalPages="totalPages"
                   :pageNum="pageNum"
                   :pageSize="pageSize"
                   @page-change="onChange"
        />
    </div>
</template>
<script>
import { fetchList } from "../api/free";
import { remove } from "../api/list";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      form: {},
      list: [],
      loading: false,
      total: 0,
      totalSize: 0,
      totalPages: 0,
      pageNum: 1,
      pageSize: 10,
      tableColumns: [
        {
            key: 'code',
            title: '资产编号',
            field: 'code',
            infotype: 'text'
        },
        {
            key: 'name',
            title: '资产名称',
            field: 'name',
            infotype: 'text',
        },
        {
            key: 'brand',
            title: '品牌',
            field: 'brand',
            infotype: 'text',
        },
        {
            key: 'specification',
            title: '规格型号',
            field: 'specification',
            infotype: 'text',
        },
        {
            key: 'unit',
            title: '单位',
            field: 'unit',
            infotype: 'text',
        },
        {
            key: 'price',
            title: '单价',
            field: 'price',
            infotype: 'text',
        },
        {
            key: 'status',
            title: '资产状态',
            field: 'status',
            infotype: 'dictType',
            dictType:'AssetMaterialStatus'
        },
        {
            key: 'createAt',
            title: '入库时间',
            field: 'createAt',
            infotype: 'text',
        },
        {
            key: 'actions',
            title: '操作',
            render: {
                view: false,
                edit: true,
                delete: true
            }
        }
    ],
    };
  },
  mounted() {
    this.getUserList();
    this.getList();
  },
  computed: {
    ...mapState("userSelector", ["userList"]),

    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("AssetMaterialStatus");
    },
  },
  methods: {
    ...mapActions("userSelector", ["getUserList"]),

    getList() {
      this.loading = true;
      let { form } = this;

      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
              this.list = res.list;
              this.totalSize = res.totalSize;
              this.totalPages = res.totalPages;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
        this.pageNum  = pagination;
        this.pageSize = 10;
      this.getList();
    },
    reset() {
      this.form = {};
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },
    query() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },

    edit(text) {
      window.localStorage.setItem("materialDetail", JSON.stringify(text));
      this.$router.push(`${this.$route.path}/edit`);
    },

    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.logQuery{
    display: flex;
    justify-content: start;
    width: 80%;
}
.right ::v-deep Button{
    margin: 0 0.2rem;
}
</style>